import { Component, OnInit } from '@angular/core';
import { DomSanitizer, SafeResourceUrl } from '@angular/platform-browser';

import { UserContextService } from '../../../../core/services/user-context.service';
import { NewsHttpService } from '../../services/news-http.service';
import { INewsletter } from '../../interfaces/newsletter.interface';
import { ActivatedRoute, Params } from '@angular/router';
import {INewsHttpService} from '../../services/news-http.interface';

@Component({
    selector: 'news-detail',
    templateUrl: './news-detail.page.html',
    styleUrls: ['./news-detail.page.scss']
})
export class NewsDetailComponent implements OnInit {

    newsletter: INewsletter;
    htmlLink: SafeResourceUrl;

    constructor(
        private route: ActivatedRoute,
        private sanitizer: DomSanitizer,
        private userContextService: UserContextService,
        private newsService: INewsHttpService
    ) { }

    ngOnInit() {
        console.log('NewsDetailComponent init');

        this.route.params.subscribe(async (params: Params) => {
            const userId = this.userContextService.getUserId();
            const newsletterId: number = +params['id'];
            if (newsletterId) {
                this.newsletter = await this.newsService.get(userId, newsletterId);
                this.htmlLink = this.sanitizer.bypassSecurityTrustResourceUrl(this.newsletter.htmlLink);
                // console.log(this.newsletter);
            }
        })
    }

}
